import { type GraphicIdParam } from '@bizzdesign/shared/models';
import { mergeArrays } from '../common/array.utils';

export function generateGraphicIdParams(
  oldGraphicIds: string[],
  freshGraphicIds: string[],
): GraphicIdParam[] {
  const idsToCheck = mergeArrays<string>(freshGraphicIds, oldGraphicIds).filter(
    (id) => !!id,
  );

  return idsToCheck.map<GraphicIdParam>((id) => {
    const isDeleted =
      !freshGraphicIds.includes(id) && oldGraphicIds.includes(id);
    if (isDeleted) {
      return {
        graphicId: id,
        modifyType: 'delete',
      };
    }
    return {
      graphicId: id,
      modifyType: 'update',
    };
  });
}
